import React, {forwardRef, useCallback, useImperativeHandle, useRef} from "react";
import {useTranslation} from "react-i18next";
import {SearchInput} from "../../molecules/searchInput/SearchInput";
import {useSearchParams} from "react-router-dom";
import {removeExistingParamsArrayValue} from "../../../common/fns";
import {GetShippingAPIParams2} from "../../../api/apiTypes";
import {CustomBreadcrumb} from "../../molecules/breadCrumb/CustomBreadcrumb";
import ReturnSellerFilter from "./ReturnSellerFilter";
import SectorFilter from "./SectorFilter";
import {SelectedShippings} from "../selectedShippings/SelectedShippings";
import SellerBatchFilter from "./SellerBatchFilter";
import SellerTimeFilter from "./SellerTimeFilter";

export interface Props {
  params: GetShippingAPIParams2;
  onResetShipping: () => void;
}

export const ShippingFilter = forwardRef(({
                                            params, onResetShipping
                                          }: Props, ref) => {
  const sectorFilterRef = useRef<any>();
  const shippingRef = useRef<any>();
  const controlRef = useRef<any>();
  const [_, setSearchParams] = useSearchParams();
  const {t} = useTranslation(["shipping"]);
  
  useImperativeHandle(ref, () => ({
    setShippings: (selectedShippings) => {
      if (shippingRef.current) shippingRef.current.setShippings(selectedShippings);
      if (controlRef.current) controlRef.current.setShippings(selectedShippings);
    },
  }), []);
  
  const handleSearch = useCallback((value: string) => {
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, 'search', value), search: value
    }));
  }, [setSearchParams]);
  
  return (<>
    <div className={"breadcrumb-container"}>
      <CustomBreadcrumb shape={"round"} className={"bg-amber-800"} />
      <div className={"right"}>
        <SearchInput
          placeholder={t("search.place")}
          maxLength={16}
          size={"middle"}
          value={params.search}
          inputMode="numeric"
          onSearch={handleSearch}
        />
      </div>
    </div>
    <div className={"filter"}>
      <SellerTimeFilter
        timeStart={params.shipping_timestamp_difference_in_minute}
        timeEnd={params.shipping_timestamp_difference_end_in_minute}
        value={params.shipping_shop__uuid__in}
      />
      <SellerBatchFilter
        value={params.pickup_batch__uuid__in}
      />
      <ReturnSellerFilter
        value={params.return_order__shop__uuid__in}
      />
      <SectorFilter
        ref={sectorFilterRef}
        params={params}
        value={params.designated_sector__code__in}
      />
      <SelectedShippings
        ref={shippingRef}
        dataKey={"tracking_number"}
        onReset={onResetShipping}
      />
    </div>
  </>);
});